import store from '@/store'
import { getData } from '@core/utils/http/general'
import { ref } from '@vue/composition-api'

/**
 * Configuracion de compras
 */
export const configCompras = () => {
  const formPagos = [
    { id: 1, name: 'Pago Cheque Bancario' },
    { id: 2, name: 'Transferencia Electrónica' },
    { id: 3, name: 'Pago Efectivo' },
  ]
  const metodoPagos = [
    { id: 1, name: 'PUE-PAGO EN UNA SOLA EXHIBICION' },
    { id: 2, name: 'PPD-PAGO EN PARCIALIDADES O DIFERIDO' },
  ]
  const UsosCFDI = [
    { id: 1, name: 'Devoluciones, descuentos o bonificaciones' },
    { id: 2, name: 'Gastos en general' },
    { id: 3, name: 'Por definir' },
    { id: 4, name: 'D10 - Pagos por servicios educativos (colegiaturas)' },
  ]

  return {
    formPagos,
    metodoPagos,
    UsosCFDI,
  }
}

/**
 * Informacion de la solicitud interno
 * @param {*} idOrden ide la orden
 * @param {*} mtr matricula del alumno
 * @param {*} personafk Id de persona
 * ! decrapted
 */
export const ordenInfo = (idOrden, mtr, personafk) => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 6,
    orden: idOrden,
    matricula: mtr,
    personafk,
    // token: store.state.cuenta.session.token,
  }
  // const webservice = (!store.state.cuenta.session.token) ? 'wsinscripcion' : 'wscompras'
  getData(paramsRequest, 'wsinscripcion')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve(response.data)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

/**
 * load Catalogos
 * @returns 3 catalogos para subir transaccion
 */
export const loadCatalogos = () => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: (!store.state.cuenta.session.token) ? 2 : 30,
    token: store.state.cuenta.session.token,
  }
  const webservice = (!store.state.cuenta.session.token) ? 'wsinscripcion' : 'wscompras'
  getData(paramsRequest, webservice)
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve(response.data)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

/**
 * Lista de becas disponibles
 */
export const TipoBecaaList = nivel => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 13,
    token: store.state.cuenta.session.token,
    nivel,
  }

  getData(paramsRequest, 'wscompras')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) resolve(response.data.datos)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

/**
 * Datos de Facturacion
 * @param {config} datos de la api tanto interno como externo
 */
export const getdf = config => new Promise((resolve, reject) => {
  const { ws, matricula, IdPersona } = config
  const paramsRequest = ref({})
  paramsRequest.value = {
    action: 9,
    matricula,
    personafk: IdPersona,
  }
  // Verificar si el rol es servicios escolares
  if (store.state.cuenta.session.token) {
    if (ws !== 'wsinscripcion') {
      paramsRequest.value.token = store.state.cuenta.session.token
    }
  }

  getData(paramsRequest.value, ws)
    .then(response => {
      if (response.status === 500) {
        reject(response.data.message)
      } else resolve(response.data)
    })
    .catch(err => { reject(err) })
})

/**
 * Detalle de Factura interna o publica
 * @param {*} IdFact id de factura
 * @param {*} Idorden id de la orden
 */
// export const detailFactura = (IdFact, Idorden) => new Promise((resolve, reject) => {
//   const webservice = (!store.state.cuenta.session.token) ? 'wsinscripcion' : 'wscompras'
//   const paramsRequest = {
//     action: 10,
//     IdFact,
//     orden: Idorden,
//     token: store.state.cuenta.session.token,
//   }
//   getData(paramsRequest, webservice)
//     .then(response => {
//       if (response.status === 500) {
//         reject(response.data.message)
//       } else resolve(response.data)
//     })
//     .catch(err => { reject(err) })
// })

/**
 * Lista de planes internas,
 * @returns Lista de planes
 */
export const listaPlanes = inplan => new Promise((resolve, reject) => {
  const wstype = (!store.state.cuenta.session.token) ? 'wsinscripcion' : 'wscompras'
  const paramsRequest = ref({
    action: 17,
    plan: inplan,
    pollo: '987',
    token: store.state.cuenta.session.token,
  })
  getData(paramsRequest.value, wstype)
    .then(response => {
      if (response.status === 200 && response.data.status === 200) resolve(response.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

/**
 * Lista de cuatrimestres disponibles por plan interna
 * @param {*} planId id de plan por parte del alumno
 */
export const listaCuatrimestres = planId => new Promise((resolve, reject) => {
  getData({ action: 32, token: store.state.cuenta.session.token, planId }, 'wscompras')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) resolve(response.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
